import { render, staticRenderFns } from "./EditalFooter.vue?vue&type=template&id=37c4049e&scoped=true&lang=pug&"
import script from "./EditalFooter.vue?vue&type=script&lang=js&"
export * from "./EditalFooter.vue?vue&type=script&lang=js&"
import style0 from "./EditalFooter.vue?vue&type=style&index=0&id=37c4049e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c4049e",
  null
  
)

export default component.exports